import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  Card,
  CardContent,
  Paper,
  ListItemIcon,
  ListItem,
  CircularProgress,
  ListItemText,
  Button,
  Chip,
  TextField,
  Stack,
  Dialog,
  DialogContent,
} from "@mui/material";

import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ImageIcon from "@mui/icons-material/Image";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PersonIcon from "@mui/icons-material/Person";
import OurLanguages from "./app/OurLanguages";
import SchoolIcon from "@mui/icons-material/School";

import { Psychology as BrainIcon } from "@mui/icons-material";
import { VideoPlayer } from "./app/HelpDialogItems";

import FunctionsSwitcherGrid from "./app/FunctionsSwitcherGrid";
import FunctionsSwitcherHoriz from "./app/FunctionsSwitcherHoriz";
import { Grading as GradingIcon } from "@mui/icons-material";
import OurModels from "./app/OurModels";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Functions from "./Functions";
import AIAct from "./AIAct";
import PricesSection from "./PricesSection";
import { useNavigate } from "react-router-dom";
import FunctionsSwitcher from "./app/FunctionsSwitcher";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import LanguageSelector from "./app/LanguageSelector";

import OpenInNew from "@mui/icons-material/OpenInNew";

import TeacherStatsSection from "./TeacherStatsSection";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import CustomInputSwitch from "./app/CustomInputSwitch"; // Add this import at the top with other impor
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BackgroundAndVisionSection from "./BackgroundAndVisionSection";
import { useSnackbar } from "./app/SnackbarHandler";

import HelpContent from "./app/HelpContent";

import ContactForm from "./ContactForm";
import StarIcon from "@mui/icons-material/Star";
import StartPageFAQSection from "./StartPageFAQSection";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Link as MuiLink } from "@mui/material";

import {
  East as ArrowIcon,
  AssignmentTurnedIn as ClipboardIcon,
} from "@mui/icons-material";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // Changed import
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import WestIcon from "@mui/icons-material/West";

import { Helmet } from "react-helmet-async";
// **Newly Added Icon Imports**
import { features } from "./app/functions";

import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

import { motion } from "framer-motion";
import { getAIModelImage } from "./app/TestComponents2";

import UniversitySection from "./UniversitySection";

import FAQSection from "./FAQSection";
import Logger from "./app/Logger";
import TestimonialsSection from "./TestimonialsSection";
import {
  GradientBackground,
  StyledButton,
  FeatureSection,
  FeatureList,
  ResponsiveVideo,
} from "./StyledComponents";

import { getStyles } from "./index";

import Header from "./Header";
import Footer from "./Footer";

import QuizIcon from "@mui/icons-material/Quiz";
import EventNoteIcon from "@mui/icons-material/EventNote";
import SecurityIcon from "@mui/icons-material/Security";
import MicIcon from "@mui/icons-material/Mic";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import TranslateIcon from "@mui/icons-material/Translate";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
const API_URL =
  process.env.NODE_ENV === "production" ? "/api" : "http://localhost:3001/api";

const ModernStuderaAIWebsite = ({ toggleDarkMode, isDark }) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const { showSnackbar } = useSnackbar();
  const [language, setLanguage] = useState("svenska"); // Add language state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(1);
  const [openVideoDialog, setOpenVideoDialog] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const navigate = useNavigate();

  const contactFormRef = useRef(null); // Add ref for ContactForm

  const uspData = [
    {
      id: 1,

      heading: "Lektioner",
      description:
        "Generera lektioner med AI på bara några sekunder. Basera lektionen på valfritt underlag. Spara, skriv ut eller dela med elever.",
      link: "/lektioner",
      buttonText: "Läs mer",
      icon: <SchoolIcon sx={{ fontSize: 45 }} />,
      color: "#3B82F6",
    },
    {
      id: 2,

      heading: "Quiz",
      description:
        "Generera quiz baserat på valfritt underlag & välj mellan flera olika frågetyper. Skriv ut eller dela med elever och övervaka resultaten i realtid.",
      link: "/quiz",
      buttonText: "Läs mer",
      icon: <BrainIcon sx={{ fontSize: 45 }} />,
      color: "#9333EA",
    },

    {
      id: 3,

      heading: "Bedömning",
      description:
        "Bedöm elevtexter med AI. Välj bland våra egna bedömningsmatriser eller skapa en egen. Tillgång till resultattavla och mycket mer.",
      link: "/bedomning",
      buttonText: "Läs mer",
      icon: <ClipboardIcon sx={{ fontSize: 45 }} />,
      color: "#b45309",
    },

    {
      id: 4,

      heading: "Flashcards",
      description:
        "Generera flashcards med AI baserat på valfritt underlag. Lägg till bilder & dela med elever.",
      link: "/flashcards",
      buttonText: "Läs mer",
      icon: <ViewAgendaIcon sx={{ fontSize: 45 }} />,
      color: "#22C55E",
    },
    {
      id: 5,

      heading: "Lektionsplanering",
      description:
        "Låt Studera.ai generera lektionsplanering inom valfritt ämne. Bestäm längd på lektionen och vilka sektioner som ska ingå.",
      link: "/lektionsplanering",
      buttonText: "Läs mer",
      icon: <EventNoteIcon sx={{ fontSize: 45 }} />,
      color: "#444444",
    },

    {
      id: 6,

      heading: "Podcast",
      description:
        "Generera podcast med AI baserat på valfritt underlag. Välj mellan 50 olika språk & konfiguera ton och stil. Dela med elever.",
      link: "/podcast",
      buttonText: "Läs mer",
      icon: <MicIcon sx={{ fontSize: 45 }} />,
      color: "#5760c4",
    },

    {
      id: 7,

      heading: "Bilder",
      description:
        "Generera kompletterande bilder till ditt pedagogiska material med tillgång till ditt egen personliga arkiv.",
      link: "/bilder",
      buttonText: "Läs mer",
      icon: <ImageIcon sx={{ fontSize: 45 }} />,
      color: "#5760c4",
    },

    {
      id: 8,

      heading: "Assistenter",
      description:
        "Träna din egen AI-assistent och dela med elever, eller skapa en enklare AI-assistent och konfiguera hur den ska bete sig.",
      link: "/assistenter",
      buttonText: "Läs mer",
      icon: <SmartToyIcon sx={{ fontSize: 45 }} />,
      color: "#EF4444",
    },

    {
      id: 9,

      heading: "Högskoleprov",
      description:
        "Vi har alla gamla högskoleprov där eleverna kan få ledtrådar och öka sin förståelse genom att få stöd via AI.",
      link: "/hogskoleprovet",
      buttonText: "Läs mer",
      icon: <HistoryEduIcon sx={{ fontSize: 45 }} />,
      color: "#0f172a",
    },

    // {
    //   id: 11,

    //   heading: "Tryggt och säkert, även med AI-teknologi",
    //   description:
    //     "På Studera.ai prioriterar vi datasäkerhet och säkerställer att ingen användarinformation delas med våra AI-modeller.",
    //   link: "/app",
    //   buttonText: "Läs mer",
    //   icon: <SecurityIcon sx={{ fontSize: 45 }} />,
    // },

    // {
    //   id: 12,

    //   heading: "Lektioner i enlighet med Skolverkets kursplan",
    //   description:
    //     "Vi har koll på alla styrdokument från Skolverket, så du kan generera lektioner i enlighet med kursplan för respektive ämne och årskurs.",
    //   link: "/app",
    //   buttonText: "Läs mer",
    //   icon: <MenuBookIcon sx={{ fontSize: 45 }} />,
    // },
    // {
    //   id: 13,

    //   heading: "Stöd för över 50 språk",
    //   description:
    //     "Generera pedagogiskt material på över 50 språk. Vi vill att alla - oavsett kulturell bakgrund - ska kunna använda vår tjänst.",
    //   link: "/app",
    //   buttonText: "Läs mer",
    //   icon: <TranslateIcon sx={{ fontSize: 45 }} />,
    // },
  ];

  const instructionItems = [
    "Generera lektioner med AI på nolltid",
    "Bedöm texter med bedömningsmatriser",
    "Generera quiz, flashcards & bilder",
    "Generera lektionsplaneringar & PowerPoints",

    "Trygg och säker hantering av personlig integritet och GDPR",
    "Används av lärare, elever, studenter, läxhjälpare och vikarier",
    "Stöd för över 50 språk",
  ];

  const InstructionItem = ({ text }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 1.5,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 2,
        }}
      >
        <CheckIcon sx={{ fontSize: 16, color: "white" }} />
      </Box>
      <Typography
        sx={{
          color: "rgba(255, 255, 255, 0.8)",
          fontSize: "1.1rem",
          lineHeight: 1.5,
          fontWeight: 500,
        }}
      >
        {text}
      </Typography>
    </Box>
  );

  //

  const scrollToContact = (e) => {
    e.preventDefault();
    contactFormRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>
          Studera.ai — AI-verktyg för lärare, pedagoger, elever & skolor
        </title>
        <meta
          name="description"
          content="AI-verktyg för elever, lärare, pedagoger & skolor. Upptäck framtidens lärande genom att använda AI-verktyg som stöd, inte som ersättning."
        />

        {/* Open Graph tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://studera.ai" />
        <meta
          property="og:title"
          content="Studera.ai — AI-verktyg för lärare, pedagoger & elever"
        />
        <meta
          property="og:description"
          content="AI-verktyg för elever, lärare, pedagoger & skolor. Upptäck framtidens lärande genom att använda AI-verktyg som stöd, inte som ersättning."
        />
        <meta property="og:image" content="https://studera.ai/img/AI.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Studera.AI" />

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://studera.ai" />
        <meta
          name="twitter:title"
          content="Studera.ai — AI-verktyg för lärare, pedagoger, elever & skolor"
        />
        <meta
          name="twitter:description"
          content="AI-verktyg för elever, lärare, pedagoger & skolor. Upptäck framtidens lärande genom att använda AI-verktyg som stöd, inte som ersättning."
        />
        <meta name="twitter:image" content="https://studera.ai/img/AI.png" />
      </Helmet>
      <Header contactFormRef={contactFormRef} />

      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
          minHeight: "100vh",
        }}
      >
        <GradientBackground className="gradient-background">
          <Container
            maxWidth="xl"
            sx={{
              pt: { xs: 10, md: 21 },
              pb: { xs: 5, md: 2 },
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "60%" },
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <Box sx={{ pl: { xs: 0, md: 4 } }}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                >
                  <Box
                    sx={{ display: "flex", mb: 4, justifyContent: "center" }}
                  >
                    <Chip
                      label={
                        <span>
                          Studera.ai{" "}
                          <span style={{ opacity: 0.7 }}>
                            &nbsp;•&nbsp; Framtidens lärande
                          </span>
                        </span>
                      }
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        color: "white",
                        fontWeight: "600",
                        fontSize: "0.8rem",
                        padding: "2px 14px",

                        borderRadius: "16px",
                        "& .MuiChip-label": {
                          padding: "0 4px",
                        },
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h2"
                    component="h1"
                    gutterBottom
                    sx={{
                      fontWeight: 700,

                      fontSize: { xs: "2.5rem", md: "4rem" },
                    }}
                  >
                    AI-verktyg för lärare, elever & studenter
                  </Typography>

                  <Box sx={{ mt: 4, mb: 0, display: "none" }}>
                    {instructionItems.map((item, index) => (
                      <InstructionItem key={index} text={item} />
                    ))}
                  </Box>
                  <Box
                    sx={{
                      fontSize: { xs: "1.2rem", md: "1.4rem" },
                      fontWeight: "400",
                      color: "#e5e5e5",

                      width: { xs: "100%", md: "80%" },
                      margin: "0 auto",
                      mt: 3,
                      mb: 3,
                    }}
                  >
                    Generera lektioner, podcasts, bedöm texter, generera prov,
                    quiz, flashcards, bilder och lektionsplaneringar – allt med
                    AI.
                    {/*En smart
                    plattform för lärare, elever och studenter, GDPR-säkert och
                    med stöd för över 50 språk.*/}
                  </Box>

                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center", // Center everything horizontally on all screen sizes
                      mt: { xs: 5, md: 5 },
                      mb: { xs: 3, md: 5 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center", // Vertically center the content
                      }}
                    >
                      <Box sx={{ display: "flex", ml: -1 }}>
                        {[
                          "https://firebasestorage.googleapis.com/v0/b/studeraai.appspot.com/o/teacherImages%2FZ6BLSMsm38Un5mgW0O6Z3TToHq12%2Fsve.jpg?alt=media&token=58949dc2-887c-4453-b128-b7a55468ca8e",
                          "https://firebasestorage.googleapis.com/v0/b/studeraai.appspot.com/o/teacherImages%2Fimg-P3HIslmb1xtSYDiXeU2bD.jpg?alt=media&token=b4ea68c7-a1de-42f2-a1ac-e06f736f6943",
                          "https://firebasestorage.googleapis.com/v0/b/studeraai.appspot.com/o/misc%2Fl%C3%A4rare%2Fengelska.png?alt=media&token=8c3140b4-1b18-4bb6-bcc3-57039372bf6d",
                        ].map((imgPath, i) => (
                          <Box
                            key={i}
                            component="img"
                            src={imgPath}
                            sx={{
                              width: { xs: 36, sm: 44 },
                              height: { xs: 36, sm: 44 },
                              borderRadius: "50%",
                              border: "2px solid white",
                              objectFit: "cover",
                              ml: i > 0 ? -2 : 0,
                              position: "relative",
                              zIndex: 3 - i,
                            }}
                          />
                        ))}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          ml: 2,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            color: "#fcd34d",
                          }}
                        >
                          {[0, 1, 2, 3, 4].map((_, i) => (
                            <StarIcon
                              key={i}
                              sx={{
                                width: { xs: 16, sm: 24 },
                                height: { xs: 16, sm: 24 },
                              }}
                            />
                          ))}
                        </Box>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "500",
                            fontSize: { xs: "0.875rem", sm: "0.9rem" },
                            color: "#e5e5e5",
                          }}
                        >
                          Uppskattad av 43,000+ användare
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      //display: "none",
                      gap: 2,
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "center",
                      mb: 8,
                    }}
                  >
                    <Link
                      to="/app/skapa-konto?ref=startpage"
                      style={{ textDecoration: "none" }}
                    >
                      <StyledButton
                        variant="blue"
                        color="primary"
                        size="large"
                        sx={{
                          borderRadius: "100px",
                          padding: "13px 50px",
                          fontSize: "20px",
                          width: "300px",
                          fontWeight: "600",
                          mt: 4,
                          backgroundColor: "#eeeeee",
                          borderBottom: "none",
                          color: "#221562",
                          "&:hover": {
                            backgroundColor: "white",
                            color: "#333",
                          },
                        }}
                      >
                        Skapa konto gratis
                      </StyledButton>
                    </Link>

                    <Link
                      to="/app/logga-in?ref=startpage"
                      style={{ textDecoration: "none", display: "none" }}
                    >
                      <StyledButton
                        variant="blue"
                        color="primary"
                        size="large"
                        sx={{
                          borderRadius: "100px",
                          padding: "13px 50px",
                          fontSize: "20px",
                          width: "250px",
                          fontWeight: "600",
                          mt: 1,
                          backgroundColor: "#eeeeee",
                          borderBottom: "none",
                          color: "#221562",
                          "&:hover": {
                            backgroundColor: "white",
                            color: "#333",
                          },
                        }}
                      >
                        Logga in
                      </StyledButton>
                    </Link>
                  </Box>
                </motion.div>
              </Box>

              {/* Image on the right */}
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                mt: 0,
                mb: 4,
              }}
            >
              <KeyboardDoubleArrowDownIcon
                sx={{
                  fontSize: "4rem",
                  color: "#ffffff",
                  animation: "bounce 2s infinite",
                }}
              />
            </Box>
          </Container>
        </GradientBackground>
        <UniversitySection bgcolor="background.paper" showHeadline={true} />
        <Box
          sx={{
            bgcolor: "background.default",
          }}
        >
          <Functions selectedUserType={0} />
        </Box>

        <style>
          {`
      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {
          transform: translateY(0);
        }
        40% {
          transform: translateY(-10px);
        }
        60% {
          transform: translateY(-10px);
        }
      }
    `}
        </style>

        <Box
          sx={{
            bgcolor: "background.default",
            py: 8,
            mt: { xs: 2, md: 8 },
            pb: 14,
            display: "none",
          }}
        >
          <Box sx={{ width: { xs: "100%", md: "1300px" }, margin: "0 auto" }}>
            <Typography
              variant="h3"
              align="center"
              gutterBottom
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "2.2rem", md: "3.2em" },
              }}
            >
              Se vad som finns
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mb: 4,
                opacity: 0.8,
                fontSize: "1.3rem",

                margin: "0 auto",
                fontWeight: "500",
                lineHeight: "31px",
                display: "block",
                mt: 2,
                textAlign: "center",
              }}
            >
              Visa funktioner för...
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: { xs: 5, md: 0 },
                mt: 4,
              }}
            >
              <CustomInputSwitch
                selectedIndex={selectedUserType}
                onIndexChange={setSelectedUserType}
                options={["Lärare", "Elever"]}
                optionIcons={[<SchoolIcon />, <PersonOutlineIcon />]} // Add your desired icons here
                theme={theme}
                width="430px"
                mobileWidth="90%"
                height="60px"
                fontSize="1.2rem"
                iconSize="1.2em" // Adjust icon size as needed
                iconSpacing="16px" // Adjust spacing between icon and text as needed
                //nonActiveColor="white"
                borderRadius="16px"
              />
            </Box>

            <Box sx={{ mt: { xs: 4, md: 8 } }}>
              <HelpContent
                overview={true}
                backgroundGradient="linear-gradient(105deg, rgb(95 74 216) 0%, rgb(77 58 176) 50%, rgb(78 59 179) 100%)"
                clipPathBackground=""
                user={{
                  accountType: selectedUserType === 1 ? "student" : "teacher",
                }}
              />
            </Box>
          </Box>
        </Box>

        <Container
          maxWidth="xl"
          sx={{ mb: 15, maxWidth: "1300px", display: "none" }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              mb: 2,
              fontSize: { xs: "2rem", md: "2.8rem" },
            }}
          >
            Generera pedagogiskt material
          </Typography>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="subtitle"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "1rem", md: "1.3rem" },
                lineHeight: 1.7,
                whiteSpace: "pre-line",
              }}
            >
              X
            </Typography>
          </Box>
          <FunctionsSwitcher
            grid={true}
            functions={[
              {
                title: "Generera",
                subtitle:
                  "Flervalsfrågor med ett korrekt svar där du väljer det alternativ som bäst besvarar frågan.",
                videoUrl:
                  "https://sportkuriren.se/wp-content/uploads/quiz-flervalsfragor-2.mp4",
                poster:
                  "https://sportkuriren.se/wp-content/uploads/quiz-flervalsfragor.png",
              },
              {
                title: "Redigera",
                subtitle:
                  "Simulera ett riktigt prov där du får visa dina kunskaper genom att formulera egna, utförliga svar.",
                videoUrl:
                  "https://sportkuriren.se/wp-content/uploads/quiz-prov-2.mp4",
                poster:
                  "https://sportkuriren.se/wp-content/uploads/quiz-prov.png",
              },
              {
                title: "Spara",
                subtitle:
                  "Välj rätt utelämnat ord i frågan för att visa att du förstår kontexten.",
                videoUrl:
                  "https://sportkuriren.se/wp-content/uploads/quiz-fyll-i-luckan-2.mp4",
                poster:
                  "https://sportkuriren.se/wp-content/uploads/quiz-fyll-i-luckan.png",
              },
              {
                title: "Dela",
                subtitle:
                  "Påståenden som är sanna eller falska och kräver att du bedömer informationens korrekthet.",
                videoUrl:
                  "https://sportkuriren.se/wp-content/uploads/quiz-sant-falskt-2.mp4",
                poster:
                  "https://sportkuriren.se/wp-content/uploads/quiz-sant-falskt.png",
              },
              {
                title: "X",
                subtitle:
                  "Traditionella nutidsfrågor i 1X2-format med svarstalong och facit.",
                videoUrl:
                  "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-3.mp4",
                poster:
                  "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-3.png",
              },
            ]}
          />
        </Container>
        {/* Example Lessons Grid Section */}
        <Box sx={{ bgcolor: "background.paper", py: 8, display: "none" }}>
          <Container maxWidth="lg">
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                mb: 7,
                textAlign: "center",
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              Exempel på lektioner du kan generera
            </Typography>

            <Grid container spacing={4}>
              {[
                {
                  title: "Svenska: Läsförståelse",
                  description:
                    "En interaktiv lektion för kreativt skrivande med övningar och exempel anpassade efter elevernas nivå.",
                  type: "image",
                  media:
                    "https://www.ilteducation.com/wp-content/uploads/2024/05/aski-raski-dator-720x482.jpg",
                  pdfUrl: "/pdfs/kreativt-skrivande.pdf",
                },

                {
                  title: "Historia: Andra världskriget",
                  description:
                    "Fördjupande lektion om andra världskriget med tidslinje, kartor och diskussionsfrågor.",
                  type: "image",
                  media:
                    "https://www.ilteducation.com/wp-content/uploads/2024/05/aski-raski-dator-720x482.jpg",
                  pdfUrl: "/pdfs/andra-varldskriget.pdf",
                },

                {
                  title: "Matematik: Algebra grundkurs",
                  description:
                    "Komplett lektion i grundläggande algebra med övningsuppgifter och steg-för-steg-lösningar.",
                  type: "video",
                  media: "EB0I7YNK2ro",
                  pdfUrl: "/pdfs/algebra-grundkurs.pdf",
                },
              ].map((lesson, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      height: "100%",
                      borderRadius: 4,
                      bgcolor:
                        theme.palette.mode === "dark" ? "#15202b" : "white",
                      boxShadow: "0 10px 40px rgba(0,0,0,0.04)",
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-10px)",
                      },
                    }}
                  >
                    {lesson.type === "video" ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          height: 200,
                          borderRadius: 2,
                          mb: 2,
                          cursor: "pointer",
                          background:
                            "linear-gradient(135deg, #6366f1, #754cbf)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.02)",
                          },
                        }}
                        onClick={() => {
                          setSelectedVideoId(lesson.media);
                          setOpenVideoDialog(true);
                        }}
                      >
                        <Box
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: "50%",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2,
                          }}
                        >
                          <PlayArrowIcon
                            sx={{ fontSize: 35, color: "#6366f1" }}
                          />
                        </Box>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "white",
                            fontWeight: 500,
                          }}
                        >
                          Klicka för att se videon
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(255, 255, 255, 0.8)",
                            display: "none",
                          }}
                        >
                          Klicka för att se videon
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        component="img"
                        src={lesson.media}
                        alt={lesson.title}
                        sx={{
                          width: "100%",
                          height: 200,
                          objectFit: "cover",
                          borderRadius: 2,
                          mb: 2,
                        }}
                      />
                    )}
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                      {lesson.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "text.secondary", mb: 2 }}
                    >
                      {lesson.description}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <IconButton
                        component="a"
                        href={lesson.pdfUrl}
                        target="_blank"
                        sx={{ color: "primary.main" }}
                      >
                        <PictureAsPdfIcon />
                      </IconButton>
                    </Box>
                  </Paper>
                </Grid>
              ))}

              {/* Add this Dialog component outside the mapping, but inside your main component */}
              <Dialog
                open={openVideoDialog}
                onClose={() => {
                  setOpenVideoDialog(false);
                  setSelectedVideoId(null);
                }}
                maxWidth="md"
                fullWidth
              >
                <DialogContent sx={{ p: 0, bgcolor: "black" }}>
                  <Box
                    component="iframe"
                    src={
                      selectedVideoId
                        ? `https://www.youtube.com/embed/${selectedVideoId}?autoplay=1`
                        : ""
                    }
                    sx={{
                      width: "100%",
                      aspectRatio: "16/9",
                      border: 0,
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </DialogContent>
              </Dialog>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
              <Link to="/app/skapa-konto" style={{ textDecoration: "none" }}>
                <StyledButton
                  variant="blue"
                  size="large"
                  sx={{
                    borderRadius: "12px",
                    padding: "12px 32px",
                    fontSize: "1.1rem",
                  }}
                  endIcon={<KeyboardDoubleArrowRightIcon />}
                >
                  Se alla lektioner du kan generera
                </StyledButton>
              </Link>
            </Box>
          </Container>
        </Box>

        <Container
          maxWidth="xl"
          sx={{ bgcolor: "background.paper", py: 15, display: "none" }}
        >
          <Box textAlign="center" mb={8}>
            <Chip
              label={<span>FÖRDELAR</span>}
              sx={{
                display: "none",
                backgroundColor: "primary.main",
                color: "white",
                fontWeight: "600",
                fontSize: "0.8rem",
                padding: "2px 14px",

                borderRadius: "16px",
                "& .MuiChip-label": {
                  padding: "0 4px",
                },
              }}
            />

            <Typography
              gutterBottom
              sx={{
                mb: 2,
                mt: 3,
                fontWeight: "600",
                fontSize: "3rem",
              }}
            >
              Så fungerar det
            </Typography>
          </Box>

          <Grid
            container
            spacing={0}
            sx={{ width: { xs: "100%", md: "85%" }, margin: "0 auto" }}
          >
            <Grid item xs={12} md={4} sx={{ mb: { xs: 3, md: 0 } }}>
              <Box
                sx={{
                  bgcolor: "#f8f6ff",
                  p: 5,
                  borderRadius: 4,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  height: "100%",
                  marginRight: { xs: 0, md: -5 },
                  border: "1px solid #ac73ff3d",
                }}
              >
                <Box sx={{ mb: 4 }}>
                  <img
                    src="https://sportkuriren.se/wp-content/uploads/magic-wand.png"
                    width="50px"
                  />
                </Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "500", fontSize: "1.7rem" }}
                >
                  Generera pedagogiskt material med AI
                </Typography>
                <Typography color="text.secondary" sx={{ mr: 5 }}>
                  Generera quiz, flashcards, lektioner, podcasts & bilder
                  baserat på valfritt underlag.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4} sx={{ mb: { xs: 3, md: 0 } }}>
              <Box
                sx={{
                  bgcolor: "#f6f1ff",
                  p: 5,
                  borderRadius: 4,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  height: "100%",
                  marginRight: { xs: 0, md: -5 },
                  border: "1px solid #ac73ff3d",
                }}
              >
                <Box sx={{ mb: 4 }}>
                  <img
                    src="https://sportkuriren.se/wp-content/uploads/artificial-intelligence.png"
                    width="50px"
                  />
                </Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "500", fontSize: "1.7rem" }}
                >
                  Välj mellan flera olika AI-modeller
                </Typography>
                <Typography color="text.secondary" sx={{ mr: 5 }}>
                  Du kan välja vilken AI-modell som ska generera innehållet.
                  Antingen vår egen modell eller ett urval av andra populära
                  modeller.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "#f0e8ff",
                  p: 5,
                  borderRadius: 4,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  height: "100%",
                  border: "1px solid #ac73ff3d",
                }}
              >
                <Box sx={{ mb: 4 }}>
                  <img
                    src="https://sportkuriren.se/wp-content/uploads/share.png"
                    width="50px"
                  />
                </Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "500", fontSize: "1.7rem" }}
                >
                  Dela med elever
                </Typography>
                <Typography color="text.secondary">
                  Du kan dela allt som genereras med elever med några få klick.
                  Antingen via Studera.ai (elevkonto krävs) eller via en länk
                  (inget elevkonto krävs).
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>

        <AIAct theme={theme} styles={styles} frontPage={true} />

        <Box sx={{ bgcolor: "background.default", py: 8, mt: 8 }}>
          <Container maxWidth="lg">
            <OurModels styles={styles} />
          </Container>
        </Box>

        <Box sx={{ bgcolor: "background.paper", py: 8, mt: 8 }}>
          <Container
            maxWidth="xl"
            sx={{ mb: { xs: 5, md: 20 }, maxWidth: "1300px" }}
          >
            <OurLanguages
              title="Språk vi stöjder"
              subtitle="När du genererar innehåll med vår AI-modell kan du välja mellan följande språk"
              theme={theme}
              styles={styles}
            />
          </Container>
        </Box>

        <Container
          maxWidth="xl"
          sx={{
            paddingTop: 22,
            paddingBottom: 22,
            textAlign: "center",

            backgroundImage:
              'url("/img/hepp.svg"), radial-gradient(circle, rgb(106, 80, 243), rgb(62, 46, 141) 82%)',
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              fontWeight: "bold",
              fontSize: "2.6em",
              color: "white",
              display: "block",
              mb: 3,
            }}
          >
            Prova helt gratis
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, color: "#E7E7E8" }}>
            Anslut dig till 43,000+ lärare och elever som använder Studera.ai
          </Typography>
          <Link
            to="/app/skapa-konto?ref=startpage"
            style={{ textDecoration: "none" }}
          >
            <StyledButton
              variant="blue"
              color="primary"
              size="large"
              sx={{
                borderRadius: "100px",
                padding: "13px 50px",
                fontSize: "20px",
                width: "300px",
                fontWeight: "600",
                mt: 4,
                backgroundColor: "#eeeeee",
                borderBottom: "none",
                color: "#221562",
                "&:hover": {
                  backgroundColor: "white",
                  color: "#333",
                },
              }}
            >
              Skapa konto gratis
            </StyledButton>
          </Link>
        </Container>
        <div ref={contactFormRef}>
          <ContactForm showMoreFields={true} />
        </div>
        <Box sx={{ display: "none" }}>
          <TestimonialsSection source="teacher" />
        </Box>
        <Box
          sx={{ bgcolor: "background.default", py: 8, mt: 8, display: "none" }}
        >
          <Container maxWidth="lg">
            <Grid
              container
              spacing={10}
              alignItems="center"
              justifyContent="center"
            >
              <Grid
                item
                xs={12}
                md={10}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h3"
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "2.3em",
                    mb: 2,
                  }}
                >
                  Vanliga frågor och svar
                </Typography>

                <Typography
                  variant="h6"
                  paragraph
                  color="text.secondary"
                  sx={{ textAlign: "center", mb: 3 }}
                >
                  Om du har några andra frågor — vänligen{" "}
                  <MuiLink
                    onClick={scrollToContact}
                    sx={{
                      color: "text.secondary",
                      textDecoration: "none",
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    kontakta oss
                  </MuiLink>
                </Typography>

                <Box sx={{ width: "100%" }}>
                  <StartPageFAQSection />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box sx={{ py: 14, backgroundColor: theme.palette.background.paper }}>
          <TeacherStatsSection />
        </Box>
        <Box
          sx={{
            display: "none",
            py: 14,
            backgroundColor: theme.palette.background.default,
          }}
        >
          <Container>
            <Typography
              variant="h3"
              align="center"
              sx={{
                fontWeight: "bold",
                fontSize: "2.3em",
                mb: 3,
              }}
            >
              Hitta rätt prisplan för dig
            </Typography>

            <Typography
              variant="h6"
              paragraph
              color="text.secondary"
              sx={{ textAlign: "center", display: "block", mb: 6 }}
            >
              Hittar du ingen prisplan som passar dig — vänligen{" "}
              <MuiLink
                onClick={scrollToContact}
                sx={{
                  color: "text.secondary",
                  textDecoration: "none",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                kontakta oss
              </MuiLink>
            </Typography>

            <PricesSection styles={styles} />
          </Container>
        </Box>
        <BackgroundAndVisionSection contactFormRef={contactFormRef} />
        <Box sx={{ display: "none" }}>
          {features
            .filter((feature) => feature.models && feature.models.length > 0)
            .map((feature) => (
              <FeatureSection
                key={feature.title}
                id={feature.title.toLowerCase().replace(/ /g, "-")}
                sx={{
                  bgcolor: "background.default",
                  padding: { xs: "30px 0px", md: "80px 0px" },
                }}
              >
                <Container>
                  <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={12} sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h3"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          fontSize: { xs: "1.6em", md: "2.3em" },
                          textAlign: "center",
                        }}
                      >
                        {feature.title}
                      </Typography>
                      <Typography
                        variant="h6"
                        paragraph
                        color="text.secondary"
                        sx={{ textAlign: "center" }}
                      >
                        {feature.description}
                      </Typography>

                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        sx={{ marginTop: "20px" }}
                      >
                        {feature.models.map((model, idx) => (
                          <Grid item xs={12} sm={6} md={4} key={idx}>
                            <Card
                              sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: 2,
                                boxShadow: "none",
                                transition: "transform 0.3s, box-shadow 0.3s",
                                "&:hover": {
                                  transform: "translateY(-10px)",
                                },
                              }}
                            >
                              <CardContent sx={{ textAlign: "center" }}>
                                <Box
                                  component="img"
                                  src={getAIModelImage(model.name)}
                                  alt={model.name}
                                  sx={{
                                    width: 60,
                                    height: 60,
                                    mb: 2,
                                    borderRadius: "9px",
                                  }}
                                />
                                <Typography variant="h6" gutterBottom>
                                  {model.name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {model.description}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>

                      <Box mt={4} display="flex" justifyContent="center">
                        <Link
                          to={
                            feature.goDirectlyToApp
                              ? "/app/skapa-konto"
                              : `/funktioner/${feature.title.toLowerCase().replace(/ /g, "-").replace(/å/g, "a").replace(/ä/g, "a").replace(/ö/g, "o")}`
                          }
                          style={{ textDecoration: "none" }}
                        >
                          <StyledButton
                            variant={
                              theme.palette.mode === "light"
                                ? "purp"
                                : "contained"
                            }
                            color="primary"
                            endIcon={<WestIcon />}
                          >
                            Lär dig mer
                          </StyledButton>
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Container>
              </FeatureSection>
            ))}
        </Box>
        {/*<MediaSection  bgcolor='background.default'  />*/}
        <Footer contactFormRef={contactFormRef} />
      </Box>
      {!isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: 9999,
          }}
        >
          <IconButton onClick={toggleDarkMode}>
            {isDark ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Box>
      )}
    </>
  );
};

export default ModernStuderaAIWebsite;
